import {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";

const useInfo = (type = "") => {
    const {t} = useTranslation();

    const [info, setInfo] = useState([]);

    useEffect(() => {
        if (type === "netgraph-video") setInfo(netgraphVideoSlides);
        else if (type === "netgraph-trackpage") setInfo(netgraphTrackPageSlides);
        else if (type === "netgraph-searchbar") setInfo(netgraphSearchbar);
        else if (type === "general-searchbar") setInfo(generalSearchbar);
    }, [type]);

    const netgraphVideoSlides = [
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.SLIDE1.TITLE"),
            descriptionTag: "",
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.SLIDE2.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.SLIDE2.DESCR"),
            icon: "fab fa-hubspot text-success fa-5x mb-7",
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.SLIDE3.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.SLIDE3.DESCR"),
            icon: "fab fa-gg-circle text-warning fa-5x mb-7",
        },
        // {
        //     align: "center",
        //     titleTag: t("INFOMODAL.NETGRAPH.SLIDE4.TITLE"),
        //     img: "/media/infoModals/insights.png",
        // },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.SLIDE5.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.SLIDE5.DESCR"),
            icon: "far fa-play-circle text-danger fa-5x mb-7",
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.THE_END"),
        },
    ];

    const netgraphTrackPageSlides = [
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.SLIDE1.TITLE"),
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.SLIDE2.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.SLIDE2.DESCR"),
            icon: "fab fa-hubspot text-success fa-5x mb-7",
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.TRACKPAGE.BY_TOPIC.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.TRACKPAGE.BY_TOPIC.DESCR"),

            icon: "fab fa-gg-circle text-warning fa-5x mb-7",
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.TRACKPAGE.BY_VIDEO.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.TRACKPAGE.BY_VIDEO.DESCR"),

            icon: "far fa-play-circle text-danger fa-5x mb-7",
        },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.TRACKPAGE.BY_SPEAKER.TITLE"),
            descriptionTag: t("INFOMODAL.NETGRAPH.TRACKPAGE.BY_SPEAKER.DESCR"),

            icon: "fas fa-users text-primary fa-5x mb-7",
        },
        // {
        //     align: "center",
        //     titleTag: t("INFOMODAL.NETGRAPH.SLIDE4.TITLE"),
        //     img: "/media/infoModals/insights.png",
        // },
        {
            align: "center",
            titleTag: t("INFOMODAL.NETGRAPH.THE_END"),
        },
    ];

    const netgraphSearchbar = [
        {
            title: t("INFOMODAL.NETGRAPH.SEARCHBAR.TITLE"),
            description: [t("INFOMODAL.NETGRAPH.SEARCHBAR.DESCR")],
            icon: "fab fa-searchengin text-success fa-5x mb-7",
        },
    ];

    const generalSearchbar = [
        {
            title: t("INFOMODAL.SEARCHBAR.TITLE"),
            description: [t("INFOMODAL.SEARCHBAR.DESCRIPTION")],
            icon: "fab fa-searchengin text-success fa-5x mb-7",
        },
    ];

    return info;
};

export default useInfo;
